
import { Vue, Component, Prop } from 'vue-property-decorator';
import ShowEventBase from '@/ui/components/devices/devices/base/ShowEventBase.vue';
import OutputFieldBase from '@/ui/components/devices/devices/base/OutputFieldBase.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';
import LabelUnitWrapper from '@/ui/components/devices/components/LabelUnitWrapper.vue';
import { IDevice } from '@/types/devices.types';

/**
 * Component that represent HouseConsumption device
 */
@Component({
  components: {
    ShowEventBase,
    OutputFieldBase,
    DeviceLayout,
    LabelUnitWrapper,
  },
})
export default class HouseConsumption extends Vue {
  @Prop() deviceData!: IDevice;

  get isActualValueVariableFilled() {
    return !!this.deviceData.data.mappings.OutputField_actualValue.length;
  }
}
